var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-106.2%",
    y: "-106.2%",
    width: "312.5%",
    height: "312.5%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.470588235 0 0 0 0 0.819607843 0 0 0 0 0.0901960784 0 0 0 0.245246941 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 12,
    cy: 12,
    r: 8.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm6.029 9.864L15.094 12.8a1.674 1.674 0 0 1-1.191.494c-.45 0-.874-.176-1.192-.494l-.115-.115-.312.313.114.114a1.687 1.687 0 0 1 0 2.384L9.464 18.43a1.674 1.674 0 0 1-1.192.493c-.45 0-.874-.175-1.192-.493l-1.11-1.11a1.687 1.687 0 0 1 0-2.383l2.936-2.935a1.674 1.674 0 0 1 1.191-.494c.45 0 .874.176 1.192.494l.115.115.312-.313-.114-.114a1.687 1.687 0 0 1 0-2.384l2.934-2.934a1.675 1.675 0 0 1 1.192-.494c.45 0 .874.175 1.192.493l1.11 1.11a1.687 1.687 0 0 1-.001 2.383z",
    fill: "#61A351",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.403 13.877-.567.567-.88-.88.567-.567-.115-.115a.438.438 0 0 0-.622 0L6.85 15.817a.44.44 0 0 0 0 .622l1.11 1.11a.451.451 0 0 0 .622 0l2.935-2.934a.441.441 0 0 0 0-.624l-.115-.114zM16.04 7.251a.438.438 0 0 0-.624 0l-2.935 2.935a.441.441 0 0 0 0 .623l.115.115.87-.87.88.88-.87.87.115.115a.451.451 0 0 0 .623 0l2.935-2.935a.441.441 0 0 0 0-.623l-1.11-1.11z",
    fill: "#61A351",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLink);
export default __webpack_public_path__ + "static/media/icons-link.1d98c6d841b8fa1202a6ff6a78e064ff.svg";
export { ForwardRef as ReactComponent };